import MissionLeftPanel from "./MissionLeftPanel";
import MissionRightPanel from "./MissionRightPanel";
//import Button from "../ui/Button";
//import { useTranslation } from "react-i18next";
//import { ButtonVariant } from "../../types/constants";

export default function MissionSection() {
//    const { t } = useTranslation();

    return (
        <section className="relative py-20 md:py-24 lg:py-28">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-screen h-full bg-background-400 -z-10" />

            <div className="mx-auto max-w-[360px] md:max-w-[688px] lap:max-w-[1024px] xl:max-w-[1280px] lg:max-w-[1440px] flex flex-col lap:flex-row gap-8 xl:gap-5">
                <MissionLeftPanel />
                <MissionRightPanel />
            </div>

            {/* 
            <div className="mx-auto mt-8 md:mt-10 w-full lap:hidden max-w-[360px] md:max-w-[688px] lap:max-w-[936px]">
                <Button text={t("buttons.learnMore")} variant={ButtonVariant.SECONDARY} />
            </div>
            */}
        </section>
    );
}
